import { HttpClient, HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Opdracht, UploadDocument, UploadStatusPatch } from './uploadbeheer.model';

@Injectable({ providedIn: 'root' })
export class ApUploadbeheerResource {
    private readonly httpClient = inject(HttpClient);

    private readonly baseUrl = '/services/apic-uploadbeheer/api';

    public getOpdracht(opdrachtId: string): Observable<Opdracht> {
        return this.httpClient.get<Opdracht>(`${this.baseUrl}/opdrachten/${opdrachtId}`);
    }

    public patchDocument(documentId: string, uploadStatusPatch: UploadStatusPatch): Observable<void> {
        return this.httpClient.patch<void>(
            `${this.baseUrl}/documenten/${documentId}`,
            { status: uploadStatusPatch },
            // eslint-disable-next-line @typescript-eslint/naming-convention
            { headers: { 'Content-Type': 'application/merge-patch+json' } }
        );
    }

    public postBestanden(documentId: string, files: FormData): Observable<HttpEvent<void>> {
        const uploadUrl = `${this.baseUrl}/documenten/${documentId}/bestanden`;
        return this.httpClient.request<void>(new HttpRequest('POST', uploadUrl, files, { reportProgress: true }));
    }

    public deleteDocument(documentId: string): Observable<void> {
        return this.httpClient.delete<void>(`${this.baseUrl}/documenten/${documentId}`);
    }

    /**
     * @description Use this method to register a new document for an opdracht
     * @param document The document to be registered
     * @returns the id of the new registered document
     */
    public postDocument(document: UploadDocument): Observable<string> {
        return this.httpClient
            .post<HttpResponse<void>>(`${this.baseUrl}/documenten`, document, { observe: 'response' })
            .pipe(map((response) => response.headers.get('location').split('/').reverse()[0]));
    }
}
